import React, { useState } from 'react';
import Catalog from './adminPanel/Catalog.js';
import ImagesSelector from './adminPanel/imagesSelector.js';

const menuItems = [
  {
    id: 'main',
    label: 'Main',
    note: 'Overview',
  },
  {
    id: 'images',
    label: 'Images',
    note: 'Storefront media',
  },
  {
    id: 'catalog',
    label: 'Catalog',
    note: 'Products',
  },
];

function MainDashboard({ onOpenImages, onOpenCatalog }) {
  return (
    <section className="admin-view admin-view--main">
      <div className="admin-dashboard__hero section-card">
        <div>
          <span className="eyebrow">Main</span>
          <h1>Overview</h1>
          <p>Clean control panel for storefront operations.</p>
        </div>

        <div className="admin-dashboard__hero-actions">
          <button className="admin-dashboard__link" type="button" onClick={onOpenImages}>
            Images
          </button>
          <a className="admin-dashboard__link admin-dashboard__link--ghost" href="/">
            View storefront
          </a>
        </div>
      </div>

      <div className="admin-dashboard__metric-grid">
        <article className="admin-dashboard__metric section-card">
          <span>Storefront</span>
          <strong>Online</strong>
          <p>Public site available.</p>
        </article>

        <article className="admin-dashboard__metric section-card">
          <span>Images</span>
          <strong>Ready</strong>
          <p>Media tools connected.</p>
        </article>

        <article className="admin-dashboard__metric section-card">
          <span>Catalog</span>
          <strong>Ready</strong>
          <p>Product feed connected.</p>
        </article>
        <article className="admin-dashboard__metric section-card">
          <span>Orders</span>
          <strong>Pending</strong>
          <p>Module not wired yet.</p>
        </article>
      </div>

      <div className="admin-dashboard__module-grid">
        <section className="admin-dashboard__module section-card">
          <div className="admin-dashboard__module-top">
            <span className="admin-dashboard__module-status is-live">Live</span>
            <strong>Images</strong>
          </div>
          <p>Manage carousel and feature images.</p>
          <button className="admin-dashboard__link" type="button" onClick={onOpenImages}>
            Open
          </button>
        </section>

        <section className="admin-dashboard__module section-card">
          <div className="admin-dashboard__module-top">
            <span className="admin-dashboard__module-status is-live">Live</span>
            <strong>Catalog</strong>
          </div>
          <p>Browse the current product feed.</p>
          <button className="admin-dashboard__link" type="button" onClick={onOpenCatalog}>
            Open
          </button>
        </section>

        <section className="admin-dashboard__module section-card">
          <div className="admin-dashboard__module-top">
            <span className="admin-dashboard__module-status">Planned</span>
            <strong>Orders</strong>
          </div>
          <p>Payment status and fulfillment flow.</p>
        </section>

        <section className="admin-dashboard__module section-card">
          <div className="admin-dashboard__module-top">
            <span className="admin-dashboard__module-status">Planned</span>
            <strong>Customers</strong>
          </div>
          <p>Accounts, profiles, and support tools.</p>
        </section>
      </div>
    </section>
  );
}

export default function AdminPanel({ user, setUser }) {
  const [activeView, setActiveView] = useState('main');

  const handleLogout = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem('rivemoderne_token');
    window.localStorage.removeItem('rivemoderne_user');
    window.sessionStorage.removeItem('rivemoderne_token');
    window.sessionStorage.removeItem('rivemoderne_user');
    if (typeof setUser === 'function') {
      setUser(null);
    }
    window.location.href = '/login';
  };

  return (
    <section className="admin-dashboard">
      <aside className="admin-dashboard__menu section-card">
        <div className="admin-dashboard__menu-header">
          <span className="eyebrow">Rive Moderne</span>
          <h1>Dashboard</h1>
          <p>Clean control panel for the storefront, content tools, and future shop operations.</p>
        </div>

        <nav className="admin-dashboard__menu-nav" aria-label="Admin navigation">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`admin-dashboard__menu-button${activeView === item.id ? ' is-active' : ''}`}
              type="button"
              aria-current={activeView === item.id ? 'page' : undefined}
              onClick={() => setActiveView(item.id)}
            >
              <span className="admin-dashboard__menu-label">{item.label}</span>
              <span className="admin-dashboard__menu-note">{item.note}</span>
            </button>
          ))}
        </nav>

        <div className="admin-dashboard__menu-footer">
          <div className="admin-dashboard__menu-user">
            <strong>{user?.name || 'Admin user'}</strong>
            <span>{user?.email || 'admin@rivemoderne.com'}</span>
          </div>
          <button className="admin-dashboard__logout" type="button" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </aside>

      <div className="admin-dashboard__content">
        {activeView === 'images' ? (
          <ImagesSelector />
        ) : activeView === 'catalog' ? (
          <Catalog />
        ) : (
          <MainDashboard
            onOpenImages={() => setActiveView('images')}
            onOpenCatalog={() => setActiveView('catalog')}
          />
        )}
      </div>
    </section>
  );
}
